import { render } from "./faqq.vue?vue&type=template&id=d18aed30&scoped=true"
import script from "./faqq.vue?vue&type=script&lang=js"
export * from "./faqq.vue?vue&type=script&lang=js"

import "./faqq.vue?vue&type=style&index=0&id=d18aed30&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d18aed30"]])

export default __exports__